import localforage from 'localforage';
import lodash from 'lodash';
import { configure } from 'mobx';
import { AjaxResponse } from 'rxjs/ajax';
import { AjaxBasics, BasesOptions } from './libraries';
AjaxBasics.defaultAjaxConfig.statusPath = ['status', 'code', 'errorCode'];
AjaxBasics.defaultAjaxConfig.responsePath = ['data'];
AjaxBasics.defaultAjaxConfig.messagePath = ['msg', 'message', 'errorMsg'];
AjaxBasics.defaultAjaxConfig.successStatus = [200, '200', '00000', 0];
const { weappCompatible } = AjaxBasics;
/** 处理兼容 IE */
AjaxBasics.weappCompatible = function <T>(res: AjaxResponse<T>) {
  res = weappCompatible(res);
  let response = res.response;
  if (lodash.isString(response)) {
    try {
      response = JSON.parse(response);
    } catch (error) {
      console.error('LENG ~ error', error);
    }
  }
  return lodash.assign({}, res, { response });
};
configure({ enforceActions: 'observed' });
// 持久化访问器
const LocalForage = localforage.createInstance({
  // driver: localforage.LOCALSTORAGE, // Forc
  name: process.env.StorageKey,
  storeName: process.env.StorageKey,
});

const storagePrefix = '_account_';
BasesOptions.resetConfig({
  storagePrefix: storagePrefix,
  createStorage: lodash.constant({
    clear: LocalForage.clear,
    setItem(key, value) {
      value = lodash.isString(value) ? value : lodash.cloneDeep(value);
      return LocalForage.setItem(key, value);
    },
    removeItem: LocalForage.removeItem,
    getItem: LocalForage.getItem,
  }),
});
export class ClientsEnv {
  /**
   * 获取 环境变量 可能是 ALL 模式
   * @param env
   * @returns
   */
  getProcess(env) {
    if (lodash.isObject(env)) {
      return lodash.get(env, this.APP_ENV);
    }
    return env;
  }
  /**
   * 持久化访问器
   * @memberof ClientsEnv
   */
  readonly localforage = LocalForage;
  /**
   *   share  分隔符 必须使用不会被编码的值
   * @memberof AppConfig
   */
  readonly shareSeparate = '_-_';
  // /**
  //  * 微信公众号 Appid
  //  * @memberof AppConfig
  //  */
  readonly appid = process.env.AppID;
  /**
   * 小程序原始ID
   * @memberof AppConfig
   */
  readonly appname = process.env.AppName;
  /**
   * api 地址
   * @memberof AppConfig
   */
  readonly target = process.env.Target;
  /**
   * pc 地址
   * @memberof AppConfig
   */
  readonly pcDomain = process.env.PcDomain;
  /**
   * adfs 地址
   * @memberof AppConfig
   */
  readonly adfsDomain = process.env.AdfsDomain;
  /**
   * lenovo id 地址
   * @memberof AppConfig
   */
  readonly lidDomain = process.env.lidDomain;
  /**
   * 易分析 埋点ID
   * @memberof AppConfig
   */
  readonly lenovoWebsite = process.env.LenovoWebsite;
  // /**
  //  * 客服 地址
  //  * @memberof AppConfig
  //  */
  // readonly customUrl = process.env.CustomUrl;
  /**
   * 版本信息
   * @memberof AppConfig
   */
  readonly version = process.env.Version;
  /**
   * 构建时间戳
   * @memberof AppConfig
   */
  readonly timestamp = process.env.Timestamp;
  /**
   * Node env
   * @memberof AppConfig
   */
  // @ts-ignore
  readonly NODE_ENV: 'development' | 'production' | 'test' =
    process.env.NODE_ENV;
  /**
   * Node env production
   * @memberof AppConfig
   */
  readonly production = lodash.eq(this.NODE_ENV, 'production');
  /**
   * Node env development
   * @memberof AppConfig
   */
  readonly development = lodash.eq(this.NODE_ENV, 'development');
  /**
   * xiaozhi地址
   * @memberof AppConfig
   */
  readonly xiaozhi = this.getProcess(process.env.xiaozhi);
  /**
   * Node env test
   * @memberof AppConfig
   */
  readonly test = lodash.eq(this.NODE_ENV, 'test');
  /**
   * 环境
   * @memberof AppConfig
   */
  // @ts-ignore
  readonly APP_ENV: 'develop' | 'release' | 'trial' | 'sit' | 'uat' =
    process.env.APP_ENV;
  /**
   * 本地 dev
   * @memberof AppConfig
   */
  readonly develop = lodash.eq(this.APP_ENV, 'develop');
  /**
   * 生产环境
   * @memberof AppConfig
   */
  readonly release = lodash.eq(this.APP_ENV, 'release');
  /**
   * 预览环境
   * @memberof AppConfig
   */
  readonly trial = lodash.eq(this.APP_ENV, 'trial');
  /**
   * 测试环境
   * @memberof AppConfig
   */
  readonly sit = lodash.eq(this.APP_ENV, 'sit');
  /**
   * uat环境
   * @memberof AppConfig
   */
  readonly uat = lodash.eq(this.APP_ENV, 'uat');
  /**
   * 是否浏览器环境
   * @readonly
   * @memberof ClientsEnv
   */
  static get browser() {
    return typeof window !== 'undefined';
  }
  /**
   * 微前端环境
   * @readonly
   * @static
   * @memberof ClientsEnv
   */
  static get micro() {
    if (ClientsEnv.browser) {
      return window.__MICRO_APP_ENVIRONMENT__ || false;
    }
  }
  createStorageKey(key: string) {
    return BasesOptions.createStorageKey(key);
  }
}
export default new ClientsEnv();
